(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 67154:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
}), 'CloudDownload');

exports.Z = _default;

/***/ }),

/***/ 63123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
}), 'PlaylistAdd');

exports.Z = _default;

/***/ }),

/***/ 26494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
})), 'Spa');

exports.Z = _default;

/***/ }),

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ Head; },
/* harmony export */   "Nk": function() { return /* binding */ BodyMask; }
/* harmony export */ });
/* unused harmony export Body */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Item = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Item", componentId: "sc-1lvw3w1-0" })(["width:100%;"]);



var Head = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Head", componentId: "sc-1lvw3w1-1" })(["cursor:pointer;"]);



var Body = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Body", componentId: "sc-1lvw3w1-2" })(["height:0;overflow:hidden;transition:height 0.5s ease-in-out;"]);





var BodyMask = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__BodyMask", componentId: "sc-1lvw3w1-3" })(["padding:0;margin:0;"]);













var Accordion = function Accordion(props) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _props$isOpen = props.isOpen,isOpen = _props$isOpen === void 0 ? false : _props$isOpen;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen),open = _useState[0],setOpen = _useState[1];

  var updateBodyHeight = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var el = ref.current;
    if (el) {
      // for some reason open is not upto date state which causes a close
      setOpen(function (open) {
        var bodyEl = el.querySelector(Body.toString());
        if (!open) {
          // we close
          bodyEl.style.height = '0px';
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              var height = bodyEl.
              querySelector(BodyMask.toString()).
              getBoundingClientRect().height;
              // we open
              bodyEl.style.height = "".concat(height, "px");
            });
          });
        }

        return open;
      });
    }
  }, [ref.current, open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var el = ref.current;
    if (el) {
      var body = el.querySelector(Body.toString());
      var observer = new MutationObserver(function () {
        updateBodyHeight();
      });

      var config = { childList: true, subtree: true };

      observer.observe(body, config);

      return function () {
        observer.disconnect();
        observer = null;
      };
    }
  }, []);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    updateBodyHeight();
  }, [open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (open !== isOpen) {
      setOpen(isOpen);
    }
  }, [isOpen]);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Item, { ref: ref, className: props.className, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Head, {

        onClick: function onClick() {
          if (typeof props.handleOpen === 'function') {
            props.handleOpen();
          } else {var _props$onOpenChange;
            setOpen(!open);
            props === null || props === void 0 ? void 0 : (_props$onOpenChange = props.onOpenChange) === null || _props$onOpenChange === void 0 ? void 0 : _props$onOpenChange.call(props, !open);
          }
        }, children:

        props.head }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { children: /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BodyMask, { children: props.body }) })] }));



};

/* harmony default export */ __webpack_exports__["ZP"] = (Accordion);

/***/ }),

/***/ 68722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ThreeColumnGrid; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);






var CSSGrid = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "CSSGrid", componentId: "sc-1njg7b6-0" })(["width:100%;display:grid;grid-template-columns:repeat( auto-fill,minmax(", ",1fr) );grid-gap:20px;"],




function (p) {return p.cardWidth ? "".concat(p.cardWidth, "px") : '250px';});




var ThreeColumnGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(CSSGrid).withConfig({ displayName: "CSSGrid__ThreeColumnGrid", componentId: "sc-1njg7b6-1" })(["@media (min-width:", "px){grid-template-columns:repeat(auto-fill,minmax(350px,1fr));}"],
function (props) {return props.theme.viewports.tablet;});




/* harmony default export */ __webpack_exports__["Z"] = (CSSGrid);

/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .H2SectionHeader */ .L0).withConfig({ displayName: "SectionHeader__Header", componentId: "sc-j2xtiu-0" })(["", ""],
_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .sectionTitleStyle */ .d1);











var SectionHeader = function SectionHeader(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        className: props.className,
        justifyContent: "space-between",
        alignItems: "center", children: [/*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Header, { className: "SectionHeader--H2SectionHeader", children:
            props.title }),

          props.subTitle && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, _objectSpread(_objectSpread({},
          props.subTitleStyle ?
          { customStyle: props.subTitleStyle } :
          {}), {}, { children:

            props.subTitle })),


          props.secondSubtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, { children: props.secondSubtitle })] }),

        props.button ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flexShrink: 0, ml: [40, 40, 0], children:
          props.button }) :

        null] }) }));};




/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);

/***/ }),

/***/ 83689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Thumbnail; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54444);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23502);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);














var Thumbnail = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].img.withConfig({ displayName: "Hero__Thumbnail", componentId: "sc-1sz0hnr-0" })(["position:static;width:100%;object-fit:contain;"]);






























var Hero = function Hero(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      as: _components__WEBPACK_IMPORTED_MODULE_4__/* .HeroBackground */ .Mn,
      whiteBackground: props.whiteBackground,
      backgroundImage: props.backgroundImage,
      backdrop: props.heroSection,
      flexDirection: props.reverseColumns ? 'row-reverse' : 'row',
      alignItems: "stretch",
      flexWrap: "wrap",
      className: props.className,
      px: props.px,
      py: props.py, children: [

      (props.video || props.image || props.category) && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1, width: [1, 1, 1 / 2], children: [
        props.image ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Thumbnail, {
          src: props.image,
          srcSet: props.imageSrcSet,
          sizes: props.imageSizes }) :

        null,
        props.video ? props.video : null] }),


      (props.hasOwnProperty('title') ||
      props.hasOwnProperty('description')) && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: _components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,
        width: [1, 1, 1 / 2],
        p: props.heroSection ? null : ['10px', '10px', '40px'],
        py: props.heroSection ? ['12%', '12%', '18%'] : null,
        pl: !props.reverseColumns ? null : [0, 0, 0],
        transparentColor: props.transparentColor,
        alignItems: "center", children: /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
          as: _components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapperInner */ .z5,
          flexWrap: "wrap",
          flexDirection: "column",
          justifyContent: props.vAlignment ? props.vAlignment : "center", children: [

          props.category && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .CategoryTitle */ .gI, { children: props.category }),
          props.title && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, { dark: !!props.transparentColor || props.darkTheme, children:
            props.title }),


          props.checkTags && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexWrap: "nowrap", alignItems: "flex-start", mb: "20px", children:
            props.checkTags.map(function (tag, index) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                  as: _components__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionTag */ .Z7,
                  mr: 20,
                  alignItems: "center",
                  justifyContent: "center",

                  dark: !!props.transparentColor, children: [/*#__PURE__*/

                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "ygb-icon-checkmark",
                    fontSize: "14px",
                    style: { marginRight: '10px' } }),

                  tag] }, index));}) }),





          props.subtitle ?
          props.noSubtitleWrapper ?
          props.subtitle : /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK, { dark: !!props.transparentColor || props.darkTheme, children:
            props.subtitle }) :


          null,
          props.description && typeof props.description === 'string' ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Paragraph */ .nv, {
            className: "Hero--Description",
            dark: !!props.transparentColor || props.darkTheme, children:

            props.description }) :


          props.description,

          props.actions && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
            as: _components__WEBPACK_IMPORTED_MODULE_4__/* .ActionsWrapper */ .T0,
            flexWrap: "nowrap",
            alignItems: "center",
            justifyContent: "flex-start", children:

            props.actions.map(function (action, index) {
              if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(action)) {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(action, { key: index });
              } else {
                var button = action;
                return /*#__PURE__*/(
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {

                    appearance: button.theme ? button.theme : null,
                    onClick: button.onClick,
                    href: button.href, children:

                    button.name }, index));


              }
            }) }),


          props.disclaimer ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Disclaimer */ .em, { dark: !!props.transparentColor || props.darkTheme, children:
            props.disclaimer }) :

          null] }) })] }));





};
/* harmony default export */ __webpack_exports__["Z"] = (Hero);

/***/ }),

/***/ 23502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Mn": function() { return /* binding */ HeroBackground; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "T0": function() { return /* binding */ ActionsWrapper; },
/* harmony export */   "U1": function() { return /* binding */ VideoWrapper; },
/* harmony export */   "Z7": function() { return /* binding */ SubscriptionTag; },
/* harmony export */   "em": function() { return /* binding */ Disclaimer; },
/* harmony export */   "gI": function() { return /* binding */ CategoryTitle; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "z5": function() { return /* binding */ TextWrapperInner; }
/* harmony export */ });
/* unused harmony export HeroCaption */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var VideoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__VideoWrapper", componentId: "sc-1qhd2hj-0" })(["& > *{height:100%;display:flex;align-items:center;.video-js.video-justify-content.video-js{height:100%;@media (min-width:", "px){padding-top:0;}}.vjs-poster{background-size:cover;}}"],







function (props) {return props.theme.viewports.tablet;});









var HeroBackground = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__HeroBackground", componentId: "sc-1qhd2hj-1" })(["border-radius:3px;overflow:hidden;background-color:", ";background-image:", ";background-repeat:no-repeat;background-size:cover;background-position:top center;", ";"],






function (props) {return props.whiteBackground ? 'white' : null;},
function (props) {return (
    props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : null);},



function (_ref) {var backdrop = _ref.backdrop;return (
    backdrop && "\n      &:before {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(64, 64, 64, 0.3);\n      }\n    ");});














var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__TextWrapper", componentId: "sc-1qhd2hj-2" })(["background-color:transparent;z-index:11;background-color:", ";"],


function (_ref2) {var transparentColor = _ref2.transparentColor;return (
    transparentColor ? transparentColor : null);});


var TextWrapperInner = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__TextWrapperInner", componentId: "sc-1qhd2hj-3" })(["height:100%;"]);



var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "components__Title", componentId: "sc-1qhd2hj-4" })(["margin:0;margin-bottom:20px;color:", ";font-size:34px;font-weight:bold;line-height:41px;"],


function (props) {return props.dark ? "#fff" : "#253238";});





var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "components__SubTitle", componentId: "sc-1qhd2hj-5" })(["margin:0;margin-bottom:20px;color:", ";font-size:28px;font-weight:300;line-height:36px;:empty{display:none;}"],


function (props) {return props.dark ? "#fff" : "#242424";});









var SubscriptionTag = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__SubscriptionTag", componentId: "sc-1qhd2hj-6" })(["position:relative;color:", ";color:", ";font-size:13px;font-weight:300;line-height:23px;i{&:before{color:", ";}}"],

function (props) {return props.theme.colors.neutrals.black;},
function (props) {return props.dark && "#fff";},






function (props) {return props.theme.colors.primary['pink-1'];});




var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__Paragraph", componentId: "sc-1qhd2hj-7" })(["font-size:14px;color:", ";line-height:26px;margin:0 0 20px 0;p{margin:0;}:empty{display:none;}"],

function (props) {return props.dark ? "#fff" : "#242424";});












var Disclaimer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "components__Disclaimer", componentId: "sc-1qhd2hj-8" })(["color:", ";font-size:12px;font-style:italic;line-height:23px;margin:0;margin-bottom:20px;:empty{display:none;}"],
function (props) {return props.dark ? "#fff" : "#242424";});











var ActionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__ActionsWrapper", componentId: "sc-1qhd2hj-9" })([":empty{display:none;}button{margin-right:10px;}"]);









var CategoryTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "components__CategoryTitle", componentId: "sc-1qhd2hj-10" })(["font-size:18px;font-weight:400;margin:0;"]);





var HeroCaption = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__HeroCaption", componentId: "sc-1qhd2hj-11" })(["background-color:rgba(102,124,145,0.4);padding:11px 0;color:white;font-size:16px;font-weight:600;line-height:23px;width:100%;z-index:11;"]);

/***/ }),

/***/ 68343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85169);
/* harmony import */ var _material_ui_icons_PlaylistAdd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63123);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17516);
/* harmony import */ var _material_ui_icons_Spa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26494);
/* harmony import */ var _material_ui_icons_CloudDownload__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9248);
/* harmony import */ var _ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23502);
/* harmony import */ var _ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83689);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94007);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54444);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49613);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}












var PerksWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2).withConfig({ displayName: "PerksBanner__PerksWrapper", componentId: "sc-6i1oz8-0" })(["position:relative;margin:40px 0;background-color:#6C97A7;"]);





var PerksHero = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({ displayName: "PerksBanner__PerksHero", componentId: "sc-6i1oz8-1" })(["width:100%;padding:20px;", "{width:100%;margin:0 auto;", "{font-size:34px;color:white;font-weight:500;}", "{font-size:14px;}button{color:#1C343E;}}", "{display:none;}", "{flex-wrap:wrap;justify-content:center;button{margin-bottom:10px;}}@media(min-width:", "px){padding:40px 20px;", "{width:50%;}", "{display:initial;align-self:center;width:360px;height:360px;margin:0 auto;[data-bg]{background-color:unset;background-size:contain;background-repeat:no-repeat;}}", "{flex-wrap:nowrap;justify-content:flex-start;}}"],



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .Dx,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .Paragraph */ .nv,








_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .VideoWrapper */ .U1,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .ActionsWrapper */ .T0,








function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .VideoWrapper */ .U1,













_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_3__/* .ActionsWrapper */ .T0);






var List = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].ul.withConfig({ displayName: "PerksBanner__List", componentId: "sc-6i1oz8-2" })(["color:white;font-size:16px;line-height:1.4;padding-left:0;list-style:none;li{display:flex;align-items:center;margin-bottom:20px;i:before{color:inherit;font-size:14px;}}"]);


















var hereBannerList = [
{
  icon: 'ygb-icon-playlist',
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item1" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_material_ui_icons_CloudDownload__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item2" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_material_ui_icons_Spa__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item3" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_material_ui_icons_PlaylistAdd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item4" }) }];















var PerksBanner = function PerksBanner(props) {
  var lang = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  var
  title =




  props.title,_props$bullets = props.bullets,bullets = _props$bullets === void 0 ? hereBannerList : _props$bullets,actions = props.actions,image = props.image,_props$handleJoinClic = props.handleJoinClick,handleJoinClick = _props$handleJoinClic === void 0 ? null : _props$handleJoinClic;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(PerksWrapper, { className: props.className, fullWidth: true, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(PerksHero, {
          title: title !== null && title !== void 0 ? title : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.title" }),
          image: image !== null && image !== void 0 ? image : '/static/onboarding-step2.png',
          description: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(List, { children:
            bullets.map(function (item, i) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {

                  style: { flexDirection: 'row', alignItems: 'center' }, children: [/*#__PURE__*/

                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", { style: { width: 30, display: 'block' }, children:
                    typeof item.icon === 'string' ? /*#__PURE__*/
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                      fontSize: "14px",
                      name: item.icon }) :


                    item.icon }), /*#__PURE__*/


                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                    style: { marginLeft: '10px', flex: 1, display: 'block' }, children:

                    item.text })] }, i));}) }),





          actions:
          actions !== null && actions !== void 0 ? actions : [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, _objectSpread(_objectSpread({

            appearance: "default-white" },
          typeof handleJoinClick === 'function' ?
          { onClick: handleJoinClick } :
          { href: "/".concat(lang, "/register/account") }), {}, { children: /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.cta_text" }) }), "0")],



          reverseColumns: true }) }) }));




};

/* harmony default export */ __webpack_exports__["Z"] = (PerksBanner);

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ }),

/***/ 2949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ BodyText; },
/* harmony export */   "ck": function() { return /* binding */ Item; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var _components_Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9451);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var List = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({ displayName: "SimpleAccordionList__List", componentId: "sc-tfidsa-0" })(["width:100%;display:flex;flex-direction:column;list-style:none;padding:0;"]);







var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].li.withConfig({ displayName: "SimpleAccordionList__Item", componentId: "sc-tfidsa-1" })(["width:100%;border-bottom:2px solid #d8d8d8;padding:24px 0;"]);





var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].p.withConfig({ displayName: "SimpleAccordionList__Title", componentId: "sc-tfidsa-2" })(["display:flex;justify-content:space-between;width:100%;color:#1c343e;font-weight:500;padding:10px 0px;margin:0;cursor:pointer;outline:none;"]);











var BodyText = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "SimpleAccordionList__BodyText", componentId: "sc-tfidsa-3" })(["padding:20px 0;margin:0;"]);










var SimpleAccordionList = function SimpleAccordionList(props) {
  var _props$className = props.className,className = _props$className === void 0 ? '' : _props$className,list = props.list,_props$multipleTabsOp = props.multipleTabsOpen,multipleTabsOpen = _props$multipleTabsOp === void 0 ? true : _props$multipleTabsOp;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),openItems = _useState[0],setOpenItems = _useState[1];

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(List, { className: className, children:
      list.map(function (item, i) {
        var isOpen = openItems.includes(i);
        return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Accordion__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
              head: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Title, { children: [
                item.title, /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  name:
                  isOpen ? 'ygb-icon-chevron-up' : 'ygb-icon-chevron-down' })] }),




              body: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BodyText, { children: item.body }),
              onOpenChange: function onOpenChange() {
                if (isOpen) {
                  setOpenItems(openItems.filter(function (index) {return index !== i;}));
                } else if (multipleTabsOpen) {
                  setOpenItems([].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(openItems), [i]));
                } else {
                  setOpenItems([i]);
                }
              },
              isOpen: isOpen }) }, i));



      }) }));


};

/* harmony default export */ __webpack_exports__["ZP"] = (SimpleAccordionList);

/***/ }),

/***/ 70021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97878);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var TrailerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Trailer__TrailerWrapper", componentId: "sc-191tqp1-0" })(["flex:1;position:relative;height:auto;padding-top:calc(", "%);@media (min-width:", "px){min-width:350px;}"],



function () {return (100 / 1.777).toFixed(2);},

function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;});




var TrailerVideo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_index__WEBPACK_IMPORTED_MODULE_2__["default"]).withConfig({ displayName: "Trailer__TrailerVideo", componentId: "sc-191tqp1-1" })(["position:absolute;top:0;left:0;width:100%;height:100%;"]);

















var Trailer = function Trailer(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerWrapper, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerVideo, _objectSpread({}, props)) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Trailer);

/***/ }),

/***/ 22191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85169);
/* harmony import */ var _ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83689);
/* harmony import */ var _ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23502);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_SectionHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70300);
/* harmony import */ var _components_InstructorMeta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95240);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45945);
/* harmony import */ var _components_CSSGrid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68722);
/* harmony import */ var _organisms_SimpleAccordionList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2949);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9128);
/* harmony import */ var _ecosystems_yearly_PerksBanner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68343);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94997);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49613);
/* harmony import */ var _organisms_video_player_Trailer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70021);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);




















var HeroSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "healthcare__HeroSection", componentId: "sc-qy9inp-0" })(["b{color:#253238;white-space:nowrap;}", "{padding-right:8%;margin:0 auto;", "{max-width:720px;}", "{font-size:34px;line-height:1.2;margin-bottom:0px;}", "{font-size:20px;line-height:1.4;margin-top:24px;margin-bottom:20px;}", "{font-size:13px;margin-top:10px;}@media (max-width:", "){", "{font-size:24px;}margin-top:20px;}@media (max-width:", "){padding-right:0;}}", "{width:100%;}", "{display:flex;align-items:center;}"],





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapperInner */ .z5,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK,






_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Disclaimer */ .em,




function (props) {return "".concat(props.theme.viewports.tablet, "px");},
_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,





function (props) {return "".concat(props.theme.viewports.mobile, "px");},




_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_11__/* ["default"].toString */ .ZP.toString(),



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .VideoWrapper */ .U1);





var PerksBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_ecosystems_yearly_PerksBanner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({ displayName: "healthcare__PerksBanner", componentId: "sc-qy9inp-1" })(["background-color:#d1e5e3;", "{padding-right:0;margin-left:0;}h1,p,span,ul{color:#1C343E !important;}ul{display:flex;flex-wrap:wrap;li{min-width:240px;width:50%;}}a{color:white;background-color:#87C0C1;&:hover{background-color:#87C0C1;opacity:.9;}}"],


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP);





























var ThirdSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "healthcare__ThirdSection", componentId: "sc-qy9inp-2" })(["max-width:860px;width:100%;margin:0 auto;", "{width:100%;padding:50px;margin:0 auto;", "{font-size:24px;line-height:1.2;margin-bottom:20px;}", "{font-size:20px;line-height:1.4;margin-bottom:20px;}h2{margin-bottom:0;}p,ul,li{font-size:18px;}.Hero--Description{font-size:16px;line-height:1.4;font-weight:300;margin-bottom:20px;}}img{height:400px;object-fit:contain;object-position:left;}@media (max-width:", "){", "{padding:30px;}}"],




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK,





























function (props) {return "".concat(props.theme.viewports.tablet, "px");},
_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP);





var FourthSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "healthcare__FourthSection", componentId: "sc-qy9inp-3" })(["width:100%;overflow:visible;padding-top:10px;", "{padding:20px;margin:0 auto;", "{max-width:720px;}", "{font-size:24px;line-height:1.2;margin-bottom:20px;}", "{font-size:16px;line-height:1.4;margin-bottom:20px;}", "{font-size:16px;font-weight:500;line-height:1.4;}", "{margin-bottom:20px;a{background-color:#87C0C1;&:hover{background-color:#87C0C1;opacity:.9;}}}}", "{padding:10px;}@media(min-width:", "px){padding-top:0;", "{padding:50px 20px;}", "{}}"],




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapperInner */ .z5,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .ActionsWrapper */ .T0,













_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .VideoWrapper */ .U1,



function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .VideoWrapper */ .U1);





var FAQContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2).withConfig({ displayName: "healthcare__FAQContainer", componentId: "sc-qy9inp-4" })(["box-sizing:border-box;.SectionHeader--H2SectionHeader{font-size:18px;font-weight:500;}"]);








var FAQAccordion = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_organisms_SimpleAccordionList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP).withConfig({ displayName: "healthcare__FAQAccordion", componentId: "sc-qy9inp-5" })(["max-width:840px;"]);



var heroVideo = {
  id: '2015b3b2-5a07-46c0-948f-ad5c90c5c2b1',
  identifier: '2h3z',
  title: 'Yearly-2-30sek 1920x1080.mp4',
  thumbnailUrl:
  'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/large/embed/thumbnail.jpg',
  hls:
  'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/video_hls/playlist.m3u8',
  player: {
    assets: [
    {
      src:
      'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/video_mobile_high/yearly-2-30sek-1920x1080mp4-5-video.mp4',
      resolution: 180,
      size: 1477524 },

    {
      src:
      'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/video_medium/yearly-2-30sek-1920x1080mp4-5-video.mp4',
      resolution: 360,
      size: 3115064 },

    {
      src:
      'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/video_hd/yearly-2-30sek-1920x1080mp4-5-video.mp4',
      resolution: 720,
      size: 5625516 },

    {
      src:
      'https://yogobe.23video.com/64968575/78631845/c6d769ee57449306d8a3a67f7fcb8093/video_1080p/yearly-2-30sek-1920x1080mp4-5-video.mp4',
      resolution: 1080,
      size: 11913703 }] } };





var testimonials = {
  title: 'Så här säger utvalda experter om Yogobe Health & Care:',
  testimonials: [
  {
    name: 'Mona Drar, leg. psykolog:',
    shortDescription: '',
    testimonial:
    'Att tillgängligt kunna möta patienten på dennes villkor i vardagen med kvalitativ digital hjälp till självhjälp gör skillnad på riktigt.',
    thumbnail: '/static/healthcare/Testiomial_Mona_Drar.jpeg',
    squareImage: '/static/healthcare/Testiomial_Mona_Drar.jpeg' },

  {
    name: 'Nathalie Helm, leg. läkare.',
    shortDescription: '',
    testimonial:
    'Yogobe ger inte bara behovsanpassat stöd till individen utan inspirerar, motiverar och utbildar dem som går deras digitala program inom prevention och sekundärprevention.',
    thumbnail: '/static/healthcare/Nathalie_8.jpg',
    squareImage: '/static/healthcare/Nathalie_8.jpg' },

  {
    name: 'Jovanna Stolt, fysioterapeut:',
    shortDescription: '',
    testimonial:
    'Att kunna erbjuda ett digitalt alternativ för patienter som fått fysisk aktivitet på recept ökar tillgängligheten och följsamheten till förskrivningen. På Yogobe finns inspirerande tränings- och yogaklasser för individen att utforska i sitt egna tempo och på den nivå som passar just för dagen.',
    thumbnail: '/static/healthcare/Testimonial_Jovanna_Stolt_3.jpeg',
    squareImage: '/static/healthcare/Testimonial_Jovanna_Stolt_3.jpeg' }] };




var HeathCarePage = function HeathCarePage() {var _heroVideo$player;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),readMore = _useState[0],setReadMore = _useState[1];

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        title: data.meta.title,
        description: data.meta.desc,
        thumbnailUrl: data.meta.img }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { flexDirection: "column", px: [25, 20, 20], py: 40, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(HeroSection, {
            title: data.hero.title,
            subtitle: data.hero.desc,
            actions: [],
            video:
            data.hero['video'] ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_video_player_Trailer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {

              video: heroVideo,
              thumbnailImage: heroVideo === null || heroVideo === void 0 ? void 0 : heroVideo.thumbnailUrl,
              isLimited: false,
              autoPlay: false,
              videoSources: heroVideo === null || heroVideo === void 0 ? void 0 : (_heroVideo$player = heroVideo.player) === null || _heroVideo$player === void 0 ? void 0 : _heroVideo$player.assets,
              elementID: 'trailer_video' }) :


            null,

            image: data.hero.img,
            disclaimer: data.hero.disclaimer,
            reverseColumns: true }) }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(PerksBanner, {
        title: data.blueBanner.title,
        image: "/static/healthcare/healthcare-digital.png",
        bullets: data.blueBanner.bullets,
        actions: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {

          appearance: "default-white",
          href: "/se/healthcare/programs", children:

          data.blueBanner.actions[0] }, "0")] }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { id: "more-info", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(ThirdSection, {
          title: data.main.title,
          subtitle: data.main.desc,
          description: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [
            data.main.primary,
            readMore ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [
              data.main.secondary, ' ', /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "20px", children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("img", { src: data.main.img }) })] }) :


            null] }),


          actions: [
          {
            name: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_16__/* .Trans */ .cC, {
              id:
              readMore ? /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_17__/* .i18n._ */ .ag._("pausa-smart.read-less") : /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_17__/* .i18n._ */ .ag._("pausa-smart.read-more") }),



            theme: 'outline',
            onClick: function onClick() {
              setReadMore(!readMore);
            } }] }) }), /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { style: { backgroundColor: '#d1e5e3;' }, fullWidth: true, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(FourthSection, {
            image: data.subscriptionSegment.img,
            title: data.subscriptionSegment.title,
            subtitle: data.subscriptionSegment.desc,
            description: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, { children: data.subscriptionSegment.subtitle }),

            disclaimer: data.subscriptionSegment.disclamer,
            actions: [
            {
              name: data.subscriptionSegment.actions[0],
              theme: 'stone',
              href: '/se/c/far/b/far' }],


            reverseColumns: true }) }) }),



      testimonials ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", { style: { backgroundColor: '#F5F5F5' }, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { flexDirection: "column", my: [25, 40, 40], px: [15, 20, 20], children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "50px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { title: testimonials.title }) }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_CSSGrid__WEBPACK_IMPORTED_MODULE_7__/* .ThreeColumnGrid */ .w, { children:
            testimonials.testimonials.map(function (testimonial) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 40, children: [/*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_InstructorMeta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    isClickable: false,
                    instructor: {
                      thumbnailUrl: testimonial.thumbnail,
                      name: testimonial.name,
                      shortDescription: testimonial.shortDescription } }), /*#__PURE__*/


                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_6__/* .TestimonialStatic */ .g6, { children:
                    testimonial.testimonial })] }, testimonial.name));}) })] }) }) :






      null, /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(FAQContainer, { flexDirection: "column", my: [25, 40, 40], px: [15, 25, 25], children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: [25], mx: "auto", children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { title: data.faq.title }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(FAQAccordion, { list: data.faq.items }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mt: [25], children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Disclaimer */ .em, { children: data.faq.disclamer }) })] }) })] }));






};

/* harmony default export */ __webpack_exports__["default"] = (HeathCarePage);

var data = {
  banner:
  'Erbjudandet är tidsbegränsat och avslutas senast vid midnatt på söndagen den 12 november.',
  meta: {
    title: 'Yogobe Health & Care',
    img: '/static/healthcare/Header_image_B2H_landingpage.jpg',
    desc:
    'Digitalt stöd, preventivt, samt under och efter behandling, inom stress, utmattning, nedstämdhet, depression, sömnbesvär, oro, långvarig smärta, klimakteriet m.m. samt FaR – Fysisk aktivitet på recept. Vi samarbetar med vårdgivare, försäkringsbolag och arbetsgivare.' },

  hero: {
    title: 'Yogobe Health & Care',
    desc: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: ["F\xF6r att st\xF6tta v\xE5rdgivare, arbetsgivare och individer inom prevention, promotion och som st\xF6d i behandling erbjuder Yogobe digitala verktyg i samr\xE5d med ledande experter.", /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), "Tillg\xE4ngligt, j\xE4mlikt och anpassat efter individens behov."] }),



    actions: [],
    disclaimer: '',
    video: null,
    img: '/static/healthcare/Header_image_B2H_landingpage.jpg' },

  blueBanner: {
    title: 'Vi möter individ- och patientbehov vid:',
    bullets: [
    { icon: 'ygb-icon-checkmark', text: 'Stress' },
    { icon: 'ygb-icon-checkmark', text: 'Utmattning' },
    { icon: 'ygb-icon-checkmark', text: 'Nedstämdhet' },
    { icon: 'ygb-icon-checkmark', text: 'Depression' },
    { icon: 'ygb-icon-checkmark', text: 'Sömnbesvär' },
    { icon: 'ygb-icon-checkmark', text: 'Oro' },
    { icon: 'ygb-icon-checkmark', text: 'Långvarig smärta' },
    {
      icon: 'ygb-icon-checkmark',
      text: 'Behov av FaR – Fysisk aktivitet på recept' },

    { icon: 'ygb-icon-checkmark', text: 'Klimakteriet' }],

    actions: ['Ta del av våra program'] },

  main: {
    title: '',
    desc: '',
    primary: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("h2", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Digitala och digifysiska insatser tillsammans med Yogobe" }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", { style: { color: '#3c3c3c' }, children: "Tillsammans med v\xE5rdgivare, f\xF6rs\xE4kringsbolag och arbetsgivare st\xF6ttar vi individer, medarbetare och patienter med f\xF6rebyggande insatser, samt under och efter behandling.\xA0" }) }), /*#__PURE__*/






      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "\xA0" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Varf\xF6r Yogobe Health & Care?" }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("ul", { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "Tidsbesparande f\xF6r v\xE5rdgivare och patient" }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "Kostnadseffektivt\xA0" }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "M\xF6jligg\xF6r f\xF6r fler interventioner innan, under och efter behandling" }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "God och n\xE4ra v\xE5rd p\xE5 patientens villkor" }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "H\xF6g tillg\xE4nglighet och flexibilitet f\xF6r patienten som kan delta utifr\xE5n egna f\xF6ruts\xE4ttningar" }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "Kan leda till \xF6kad f\xF6ljsamhet" }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "Egenmonitorering av behandling, som skapar f\xF6ruts\xE4ttningar till att patienten blir mer aktiv i sin rehabiliteringsprocess" }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("li", { children: "Digitala dimensioner som del i behandling frig\xF6r resurser och m\xF6jligg\xF6r att v\xE5rdpersonal kan disponera sin tid f\xF6r optimal nytta" })] }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "\xA0" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Patientfl\xF6de med v\xE5ra digitala program" }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "V\xE5ra digital program passar som en preventiv insats eller som del i behandling, men \xE4ven inf\xF6r behandlingsstart, och efter behandlingsinsats som sekund\xE4rprevention \u2013 allt f\xF6r att m\xF6ta individens behov. H\xE4r f\xF6ljer ett exempel p\xE5 ett patientfl\xF6de och hur v\xE5ra program kan fungerar som st\xF6d i behandling:" })] }),









    secondary: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("ul", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("li", { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "H\xE4lsobed\xF6mning " }), "\u2013 Inledande h\xE4lsobed\xF6mning utf\xF6rd av legitimerad v\xE5rdpersonal, s\xE5som sjuksk\xF6terska, fysioterapeut, l\xE4kare eller psykolog."] }) }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("ul", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("li", { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Behandling" }), " \u2013 Utifr\xE5n bed\xF6mning initieras en behandlingsplan anpassad efter patientens behov.\xA0 Yogobe Health & Cares digitala program tas in som st\xF6d i behandling."] }) }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("ul", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("li", { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Uppf\xF6ljning" }), " \u2013 Regelbunden uppf\xF6ljning av legitimerad v\xE5rdpersonal som kontinuerligt f\xF6ljer upp patientens m\xE5ende och utv\xE4rderar resultat."] }) }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center' }, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("img", {
          src: "/static/healthcare/Camilla_Dahlqvist_Yogobe_.jpg",
          style: {
            height: '160px',
            marginRight: '20px',
            marginBottom: '20px' } }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("span", { style: { flex: 1 }, children: ["Kontakta oss g\xE4rna f\xF6r att diskutera era behov av st\xF6d.", /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), "Camilla Dahlqvist \u2013 COO och Head of Yogobe Health & Care\xA0", /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("a", {
            href: "mailto:Camilla.Dahlqvist@yogobe.com",
            target: "_blank",
            rel: "noopener", children: "Camilla.Dahlqvist@yogobe.com" })] })] }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("strong", { children: "Forskning & evidens" }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "Yogobe arbetar med ledande experter inom v\xE5rden. Programmen \xE4r framtagna med bas i evidens och forskning med syfte att kunna erbjuda b\xE4sta m\xF6jliga digitala st\xF6d i behandling." }), /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "Tre av de program som vi erbjuder inom ramen f\xF6r Yogobe Health & Care, med fokus p\xE5 stress och oro, depression samt utmattning, leds av legitimerade psykologer och erfarna yogal\xE4rare.\xA0" }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "H\xE4r kombineras teoretisk, psykologisk kunskap med praktiska mindfulness\xF6vningar och yogasekvenser. Den psykologiska grunden bygger p\xE5 KBT, Acceptance and Commitment Therapy och Compassion-fokuserad Terapi.\xA0" }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "Psykoedukationen som anv\xE4nds inom YOMI (namnet p\xE5 dessa program) bygger p\xE5 forskning och KBT-behandling inom de n\xE4mnda tillst\xE5nden (exempelvis beteendeaktivering f\xF6r depression). Dessa program har i sin helhet unders\xF6kts i ett antal studier, alla randomiserade, kontrollerade experiment, och \xE4r under p\xE5g\xE5ende fortsatt utv\xE4rdering i samarbete med Lunds Universitet. Tre publikationer finns i dagsl\xE4get, i tidskrifterna Anxiety, Stress & Coping, PLOS och Mindfulness. Studierna visar p\xE5 goda effekter av programmet: \u201CYOMI vid stress & oro\u201D.\xA0" }), /*#__PURE__*/











      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("p", { children: "Vidare finns opublicerade resultat f\xF6r tre studier, som i dagsl\xE4get \xE4r under bearbetning. Den senaste studien, 2020, genomf\xF6rdes p\xE5 YOMI vid utmattning eller sm\xE4rta i onlineversion, och visade en tydlig f\xF6rb\xE4ttring f\xF6r gruppen med utmattning. Dessa resultat \xE4r \xE4n s\xE5 l\xE4nge opublicerade, men lovande." })] }),









    actions: [],
    img: '/static/healthcare/b2h.landing.page.jpg' },

  subscriptionSegment: {
    title: 'Yogobe och Fysisk aktivitet på recept (FaR)',
    desc: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: ["Yogobe grundades 2013 med en vision om att alla m\xE4nniskor ska ha tillg\xE5ng till verktyg och f\xF6ruts\xE4ttningar f\xF6r god fysisk och psykisk h\xE4lsa. Sedan starten har Yogobe vuxit till att bli Nordens ledande och mest omfattande digitala tj\xE4nst inom yoga, mindfulness, \xE5terh\xE4mtning, r\xF6relsetr\xE4ning och stresshantering.", /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("br", {}), "Yogobe \xE4r certifierad som godk\xE4nd aktivitetsarrang\xF6r f\xF6r FaR av Akademiskt Prim\xE4rv\xE5rdscentrum (APC). Detta som ett led i v\xE5r vision att tillg\xE4ngligg\xF6ra h\xF6gkvalitativ digitala st\xF6d och verktyg f\xF6r tr\xE4ning p\xE5 individens villkor."] }),






    subtitle: '',
    disclamer: '',
    actions: ['Läs mer om FaR och ta del av vårt innehåll!'],
    img: '/static/healthcare/FAR.B2H.jpg' },

  faq: {
    title: 'Vanliga frågor och funderingar',
    items: [
    {
      title: 'Vem kan delta i ett program?',
      body:
      'Du som har blivit ordinerad eller tilldelad access via en vårdgivare, arbetsgivare eller ett försäkringsbolag. Dessa program är del av Yogobe Health & Care och ligger utanför den prenumerationstjänst som erbjuds till privatpersoner.' },

    {
      title: 'Hur kommer jag åt mitt program?',
      body: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", { children: ["Efter att du har anm\xE4lt dig och f\xE5tt access till ett program s\xE5 har du smidig tillg\xE5ng till det via Yogobes app under \u201CMitt bibliotek\u201D eller l\xE4ngst upp p\xE5 din",



          ' ', /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("a", {
            href: "https://yogobe.com/se/me/dashboard",
            target: "_blank",
            rel: "noopener", children: "\xF6versiktssida" }),


          ' ', "n\xE4r du \xE4r inloggad p\xE5 Yogobe.com"] }) }) },





    {
      title: 'Kan företag köpa enskilda program?',
      body: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("p", { children: ["Sj\xE4lvklart! S\xE5v\xE4l arbetsgivare som f\xF6rs\xE4krings- och v\xE5rdbolag kan k\xF6pa in Yogobe och v\xE5ra program samt digitala interventioner, som st\xF6d och komplement till befintliga insatser till f\xF6rm\xE5n f\xF6r individ, medarbetare och patient. Maila oss p\xE5",




          ' ', /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("span", { style: { color: '#56b9e5' }, children: "business@yogobe.com" }), ' ', "s\xE5 ber\xE4ttar vi mer."] }) }) },





    {
      title: 'Måste jag betala?',
      body: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: "Nej. Om du kommer till Yogobe Health & Care med en accesskod som du har f\xE5tt fr\xE5n en patientf\xF6rening, v\xE5rdgivare, arbetsgivare eller f\xF6rs\xE4kringsbolag s\xE5 betalar du personligen ingenting f\xF6r \xE5tkomst till det specifika Yogobe-program eller material som du ordinerats." }) },







    {
      title: 'Hur använder jag mitt FaR-recept på Yogobe?',
      body: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: ["Om du har ett FaR-recept som du vill anv\xE4nda p\xE5 Yogobe s\xE5 ber vi dig skicka en kopia (en fotograferad bild g\xE5r bra) p\xE5 ditt FaR-recept till",


        ' ', /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("a", { href: "mailto:info@yogobe.com", target: "_blank", rel: "noopener", children: "info@yogobe.com" }), ". D\xE4refter f\xE5r du instruktioner kring hur du enkelt kommer ig\xE5ng med Yogobes FaR-specifika utbud."] }) }],








    disclamer: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: ["Vid ytterligare fr\xE5gor, funderingar eller tankar tveka inte att skriva till oss p\xE5 ", /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("a", { href: "mailto:info@yogobe.com", children: "info@yogobe.com" }), "."] }),


    actions: ['Ta del av erbjudandet'] } };

/***/ }),

/***/ 48866:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/healthcare",
      function () {
        return __webpack_require__(22191);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,3088,5675,8397,7934,2661,9774,2888,179], function() { return __webpack_exec__(48866); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);